import type { ImageLoader } from 'next/image';

import type { VehicleImage } from '@core/Entities/Vehicle/VehicleImage.entity';
import { kontentLoader } from '@kentico/KontentLoader';

const BYPASS_PROXY_REGEX = /^https?:\/\/[^/]+\/media\//i;

export const getImgLoader = (image: VehicleImage, fallbackLoader: ImageLoader): ImageLoader => {
  if (image.isKontent) return kontentLoader;
  if (BYPASS_PROXY_REGEX.test(image.url)) return ({ src }) => src;
  return fallbackLoader;
};
